import { render, staticRenderFns } from "./testimonials.component.vue?vue&type=template&id=11e1474d"
import script from "./testimonials.component.vue?vue&type=script&lang=js"
export * from "./testimonials.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports